import { render, staticRenderFns } from "./ProductCarouselLoop.vue?vue&type=template&id=79a08c99"
import script from "./ProductCarouselLoop.vue?vue&type=script&lang=js"
export * from "./ProductCarouselLoop.vue?vue&type=script&lang=js"
import style0 from "./ProductCarouselLoop.vue?vue&type=style&index=0&id=79a08c99&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports